import Rishikesh from "./../../../assets/images/rishikesh.webp";
import Manali from "./../../../assets/images/manali.png";
import Coorg from "./../../../assets/images/coorg.jpg";
import Udaipur from "./../../../assets/images/udaipur.jpeg";
import Goa from "./../../../assets/images/goa.avif";
export var Destinations = [
    {
        id: 1,
        title: "Rishikesh",
        image: Rishikesh,
    },
    {
        id: 2,
        title: "Manali",
        image: Manali,
    },
    {
        id: 3,
        title: "Goa",
        image: Goa,
    },
    {
        id: 4,
        title: "Coorg",
        image: Coorg,
    },
    {
        id: 5,
        title: "Udaipur",
        image: Udaipur,
    },
];
